import API from "./axios";

export class FinishesService {
    constructor() {

    }
    fetchFinishes(brandId:any): Promise<any> {
        return API.post(`api/index.php`, {"action":"getProductFinish","src":"dashboard","retrievalmode":"mysql" , "brandId":brandId});
    }
    createFinish( data: any): Promise<any> {
      
        return API.post(`api/index.php`, { 'action': 'FinishDataAction', 'src': 'dashboard', retrievalmode: 'mysql',  'data': [data] });
    }

    
}